export function requestObjectRequired(type = {}) {
    let config = type.workflow_config || {};
    if (typeof config === 'string') {
        try { config = JSON.parse(config); } catch (e) { config = {}; }
    }
    const catalog = config.itemCatalog || {};
    const scope = catalog.scope || catalog.catalog_scope || catalog.catalogScope || catalog.visibility ||
        catalog.mechanic_assets_scope || catalog.mechanicAssetsScope;
    if (catalog.enabled === true && catalog.type === 'mechanic_assets' &&
        String(scope || '').trim() === 'mechanic_assets_on_object') return true;
    const source = config.buildingProcess || config.building_process;
    if (source && typeof source === 'object' && !Array.isArray(source)) {
        return source.required === true || source.isRequired === true || source.required_for_create === true;
    }
    if (config.requiresBuildingProcess !== undefined) return Boolean(config.requiresBuildingProcess);
    if (config.requires_building_process !== undefined) return Boolean(config.requires_building_process);
    if (catalog.requires_building_process !== undefined) return Boolean(catalog.requires_building_process);
    return type.category === 'materials';
}
